import { contactCategoryUpdateApi } from "../../api/contactCategory/contactCategoryUpdateApi"

type PayloadShape = Parameters<typeof contactCategoryUpdateApi>[0]

export async function contactCategoryUpdateService(payload: PayloadShape, token: string) {
	return await contactCategoryUpdateApi(payload, token)
}
